import { authHeader } from '../_helpers';
import axios from 'axios';

export const trainingService = {
  getTraining,
  getTrainings,
  getQuiz,
  updateTraining
};

async function getTraining(id) {
  let user = JSON.parse(localStorage.getItem('user'));
  return axios.get(
    `${process.env.ROOT_API}/api/v1/users/${user.id}/trainings/${id}`,
    { headers: authHeader() }
  );
}

async function getTrainings() {
  let user = JSON.parse(localStorage.getItem('user'));
  return axios.get(
    `${process.env.ROOT_API}/api/v1/users/${user.id}/trainings`,
    { headers: authHeader() }
  );
}

async function updateTraining(id) {
  let user = JSON.parse(localStorage.getItem('user'));
  return axios.put(
    `${process.env.ROOT_API}/api/v1/users/${user.id}/trainings/${id}`,
    {},
    { headers: authHeader() }
  );
}

async function getQuiz(id) {
  return axios.get(
    `${process.env.ROOT_API}/crawler/api/v1/quiz/${id}`,
    {},
    { headers: authHeader() }
  );
}



// WEBPACK FOOTER //
// ./src/_services/training.js